import React, { useRef } from 'react';
import { FacebookShareButton, WhatsappShareButton } from 'react-share';
import { Button, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import CloseIcon from '../svg/CloseIcon';
import palette from '../theme/palette';
import WhatsAppIcon from '../svg/WhatsAppIcon';
import FacebookIcon from '../svg/FacebookIcon';
import CopyToClipBoardIcon from '../svg/CopyToClipboardIcon';
// import TwitterIcon from '../svg/TwitterIcon';

const useStyles = makeStyles({
  shareBtn: {
    padding: '15px 30px',
    width: '100%',
    margin: '0.4em 0'
  }
});

export default function ShareModal({ open, onClose, url }) {
  const classes = useStyles();
  const urlRef = useRef();
  const copyToClipboard = () => {
    if ('clipboard' in navigator) {
      return navigator.clipboard.writeText(url);
    }
    urlRef.current.select();
    document.execCommand('copy');
    return null;
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        Share Via
        <IconButton
          sx={{
            position: 'absolute',
            right: 8,
            top: 8
          }}
          onClick={() => onClose()}
        >
          <CloseIcon color={palette.grey[600]} height={15} width={15} />
        </IconButton>
      </DialogTitle>
      <DialogContent style={{ display: 'flex', flexDirection: 'column' }}>
        <span style={{ display: 'none' }} ref={urlRef}>
          {url}
        </span>
        <WhatsappShareButton url={url}>
          <Button variant="contained" className={classes.shareBtn}>
            <WhatsAppIcon width={25} height={25} color="white" style={{ marginRight: 15 }} />
            Share Via What's App
          </Button>
        </WhatsappShareButton>
        <FacebookShareButton url={url}>
          <Button variant="contained" className={classes.shareBtn}>
            <FacebookIcon width={25} height={25} color="white" style={{ marginRight: 15 }} />
            Share Via Facebook
          </Button>
        </FacebookShareButton>
        <Button variant="contained" className={classes.shareBtn} onClick={() => copyToClipboard()}>
          <CopyToClipBoardIcon width={25} height={25} color="white" style={{ marginRight: 15 }} />
          Copy to clipboard
        </Button>
        {/* <TwitterShareButton>
          <Button variant="contained" className={classes.shareBtn}>
            <TwitterIcon width={25} height={25} color="white" style={{ marginRight: 15 }} />
            Share Via Facebook
          </Button>
        </TwitterShareButton> */}
      </DialogContent>
    </Dialog>
  );
}

ShareModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  url: PropTypes.string
};
